 function init() {
     initScrollHeader();
     initMobileMenu();
     initTestimonialsSlider();
     initProjectsSlider();
     handleResponsive();
     window.addEventListener('resize', handleResponsive);
 }

 function initMobileMenu() {
     const toggle    = document.getElementById('mobile-menu-toggle');
     const menu      = document.getElementById('mobile-menu');
     const iconOpen  = document.getElementById('icon-menu');
     const iconClose = document.getElementById('icon-close');

     if (!toggle || !menu || !iconOpen || !iconClose) return;

     function openMenu() {
         menu.classList.remove('hidden');
         menu.setAttribute('aria-hidden', 'false');
         toggle.setAttribute('aria-expanded', 'true');
         iconOpen.classList.add('hidden');
         iconClose.classList.remove('hidden');
     }

     function closeMenu() {
         menu.classList.add('hidden');
         menu.setAttribute('aria-hidden', 'true');
         toggle.setAttribute('aria-expanded', 'false');
         iconOpen.classList.remove('hidden');
         iconClose.classList.add('hidden');
     }

     toggle.addEventListener('click', () => {
         menu.classList.contains('hidden') ? openMenu() : closeMenu();
     });

     // Zamknij po kliknięciu linka w menu
     menu.querySelectorAll('a').forEach(link => {
         link.addEventListener('click', closeMenu);
     });

     // Zamknij przy resize do desktop
     window.addEventListener('resize', () => {
         if (window.innerWidth >= 768) closeMenu();
     });
 }

 // --- Scroll header effect ---
 function initScrollHeader() {
     const header = document.getElementById('site-header');
     if (!header) return;

     const scrolledClasses = ['backdrop-blur-md', 'shadow-sm', 'border-b', 'border-border', 'bg-background/80'];

     function onScroll() {
         if (window.scrollY > 20) {
             header.classList.add(...scrolledClasses);
             header.classList.remove('bg-transparent');
         } else {
             header.classList.remove(...scrolledClasses);
             header.classList.add('bg-transparent');
         }
     }

     window.addEventListener('scroll', onScroll, { passive: true });
     onScroll();
 }

 // --- Testimonials slider ---
 function initTestimonialsSlider() {
     const slides = document.querySelectorAll('.testimonial-slide');
     const dots = document.querySelectorAll('.testimonial-dot');
     const prevBtn = document.getElementById('testimonial-prev');
     const nextBtn = document.getElementById('testimonial-next');

     if (!slides.length || !prevBtn || !nextBtn) return;

     let current = 0;
     const total = slides.length;

     function goTo(index) {
         // hide current
         slides[current].classList.add('hidden');
         dots[current].classList.remove('bg-primary', 'w-6');
         dots[current].classList.add('bg-border', 'w-2');

         // show next
         current = (index + total) % total;
         slides[current].classList.remove('hidden');
         dots[current].classList.remove('bg-border', 'w-2');
         dots[current].classList.add('bg-primary', 'w-6');
     }

     prevBtn.addEventListener('click', () => goTo(current - 1));
     nextBtn.addEventListener('click', () => goTo(current + 1));

     dots.forEach((dot, i) => {
         dot.addEventListener('click', () => goTo(i));
     });

     // Auto-advance every 6s
     setInterval(() => goTo(current + 1), 6000);
 }

 function initProjectsSlider() {
     const slider = document.getElementById('projectsSlider');
     const prevBtn = document.getElementById('prevBtn');
     const nextBtn = document.getElementById('nextBtn');

     if (!slider || !prevBtn || !nextBtn) return;

     let currentPosition = 0;
     const items = document.querySelectorAll('.project-card');
     const itemWidth = 330;

     prevBtn.addEventListener('click', prevProject);
     nextBtn.addEventListener('click', nextProject);

     function nextProject() {
         if (currentPosition > -(items.length - 3) * itemWidth) {
             currentPosition -= itemWidth;
             slider.style.transform = `translateX(${currentPosition}px)`;
         }
     }

     function prevProject() {
         if (currentPosition < 0) {
             currentPosition += itemWidth;
             slider.style.transform = `translateX(${currentPosition}px)`;
         }
     }
 }

 function handleResponsive() {
     const slider = document.getElementById('projectsSlider');
     if (!slider) return;

     if (window.innerWidth <= 768) {
         slider.style.transform = 'translateX(0)';
     }
 }

 export default {init}
